import { 
  Box, 
  Container, 
  Typography,
  useTheme,
  alpha
} from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";
import NichePigResultsTable from "./results-table";
import { NicheJobData } from "../niche-pig.slice";

const NichePigResults = (props: any) => {
  const theme = useTheme();
  const toolData = useSelector((state: RootState) => state.nichePig);
  
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            fontWeight: 700, 
            mb: 1,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Your Results Are In!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We've found several profitable niches for your next venture
        </Typography>
      </Box>

      {/* Results Table */}
      {toolData.tool.type === "NICHE" && (
        <NichePigResultsTable toolData={toolData.tool.data as NicheJobData} />
      )}
    </Container>
  );
};

export default NichePigResults;
